var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: false,
          expression: "false",
          modifiers: { fullscreen: true, lock: true },
        },
      ],
    },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticClass: "ignore-button", attrs: { offset: 20, span: 7 } },
            [
              _c(
                "el-button-group",
                [
                  _c("el-button", {
                    attrs: { type: "success", icon: "el-icon-files" },
                    on: { click: _vm.handlePrint },
                  }),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: "Cài đặt",
                        placement: "top-start",
                      },
                    },
                    [
                      _c("el-button", {
                        attrs: { type: "success", icon: "el-icon-setting" },
                        on: { click: _vm.settingFontSize },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "rows_list" },
        _vm._l(this.listData, function (itemData, index) {
          return _c(
            "div",
            {
              key: index,
              ref: "documentPrint",
              refInFor: true,
              staticClass: "row_item",
              class: {
                "half-width": _vm.view > 1,
                "full-width": _vm.view <= 1,
              },
            },
            [
              _c(
                "div",
                { staticClass: "pdf_container", style: _vm.customStyle },
                [
                  _c("br"),
                  _c(
                    "div",
                    {
                      staticClass: "content-wrapper",
                      staticStyle: { width: "100%", margin: "auto" },
                    },
                    [
                      itemData.avatar !== null
                        ? _c(
                            "el-row",
                            { staticClass: "header_kids" },
                            [
                              _c("el-col", { attrs: { span: 4 } }, [
                                _c("img", {
                                  attrs: {
                                    id: "logo_onecam",
                                    src: itemData.avatar,
                                    alt: "",
                                  },
                                }),
                              ]),
                              _c(
                                "el-col",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    "line-height": "1.5",
                                  },
                                  attrs: { span: 14 },
                                },
                                [
                                  _c("p", [
                                    _c("b", {}, [
                                      _vm._v(_vm._s(itemData.schoolName)),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(itemData.schoolAddress) + " "
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("b", [
                                      _vm._v(_vm._s(_vm.categoryBillPreview())),
                                    ]),
                                  ]),
                                ]
                              ),
                              _c(
                                "el-col",
                                { attrs: { offset: "2", span: 4 } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-content": "center",
                                        height: "100%",
                                        padding: "10px",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          "max-width": "100%",
                                          "max-height": "80%",
                                          "object-fit": "contain",
                                        },
                                        attrs: {
                                          src: itemData.imgQrBank,
                                          alt: "",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _c(
                            "el-row",
                            { staticClass: "header_kids" },
                            [
                              _c(
                                "el-col",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    "line-height": "1.5",
                                  },
                                  attrs: { offset: 6, span: 12 },
                                },
                                [
                                  _c("p", [
                                    _c("b", {}, [
                                      _vm._v(_vm._s(itemData.schoolName)),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(itemData.schoolAddress) + " "
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("b", [
                                      _vm._v(_vm._s(_vm.categoryBillPreview())),
                                    ]),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                      _c("el-row", [
                        _c("div", { staticStyle: { float: "left" } }, [
                          _c(
                            "div",
                            { staticStyle: { "font-weight": "bold" } },
                            [_vm._v("Họ tên: " + _vm._s(itemData.fullName))]
                          ),
                          _c(
                            "div",
                            { staticStyle: { "font-weight": "bold" } },
                            [_vm._v("Lớp: " + _vm._s(itemData.className))]
                          ),
                          _c("div", [_vm._v("SĐT: " + _vm._s(itemData.phone))]),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-style": "italic",
                                "margin-bottom": "3px",
                              },
                            },
                            [
                              _vm._v(
                                "\n                Ngày " +
                                  _vm._s(_vm.moment().format("DD")) +
                                  " tháng\n                " +
                                  _vm._s(_vm.moment().format("MM")) +
                                  " năm\n                " +
                                  _vm._s(_vm.moment().format("YYYY")) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]),
                        _c("div", { staticStyle: { float: "right" } }, [
                          _c(
                            "div",
                            { staticStyle: { "text-align": "right" } },
                            [_vm._v("Mã: ..........")]
                          ),
                          _c(
                            "div",
                            { staticStyle: { "text-align": "right" } },
                            [_vm._v("Quyển số: ..........")]
                          ),
                          _c(
                            "div",
                            { staticStyle: { "text-align": "right" } },
                            [_vm._v("Số: ..........")]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-bottom": "3px",
                                "text-align": "right",
                              },
                            },
                            [
                              _vm._v(
                                "\n                Đơn vị: VNĐ\n              "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _c("el-row", [
                        _c(
                          "table",
                          [
                            _c(
                              "tr",
                              {
                                staticStyle: {
                                  "background-color": "#d1d5db",
                                  "text-align": "center",
                                },
                              },
                              [
                                _c("th", { staticStyle: { width: "5%" } }, [
                                  _vm._v("STT"),
                                ]),
                                _c("th", { staticStyle: { width: "40%" } }, [
                                  _vm._v("Tên khoản thu"),
                                ]),
                                _c("th", { staticStyle: { width: "5%" } }, [
                                  _vm._v("SL"),
                                ]),
                                _c("th", { staticStyle: { width: "15%" } }, [
                                  _vm._v("Đơn giá"),
                                ]),
                                _c("th", { staticStyle: { width: "15%" } }, [
                                  _vm._v("Giảm giá"),
                                ]),
                                _c("th", { staticStyle: { width: "20%" } }, [
                                  _vm._v("Thành tiền"),
                                ]),
                              ]
                            ),
                            _vm._l(
                              itemData.dataList.slice(0, -1),
                              function (data, index) {
                                return _c("tr", { key: index }, [
                                  !_vm.isSpecialRow(data.name)
                                    ? _c("td", { attrs: { colspan: "1" } }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(index + 1) +
                                            "\n                "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        textAlign: _vm.isSpecialRow(data.name)
                                          ? "right"
                                          : "left",
                                        backgroundColor:
                                          data.name === "Tổng cộng"
                                            ? "#d1d5db"
                                            : "white",
                                      },
                                      attrs: {
                                        colspan: _vm.isSpecialRow(data.name)
                                          ? 4
                                          : 1,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(data.name) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  !_vm.isSpecialRow(data.name)
                                    ? _c("td", { attrs: { colspan: "1" } }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(data.number) +
                                            "\n                "
                                        ),
                                      ])
                                    : _vm._e(),
                                  !_vm.isSpecialRow(data.name)
                                    ? _c("td", { attrs: { colspan: "1" } }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm._f("formatCurrency")(
                                                data.price
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                      ])
                                    : _vm._e(),
                                  !_vm.isSpecialRow(data.name)
                                    ? _c("td", { attrs: { colspan: "1" } }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm._f("formatCurrency")(
                                                data.discountPrice
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        textAlign: "right",
                                        backgroundColor:
                                          data.name === "Tổng cộng"
                                            ? "#d1d5db"
                                            : "white",
                                      },
                                      attrs: {
                                        colspan: _vm.isSpecialRow(data.name)
                                          ? 2
                                          : 1,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm._f("formatCurrency")(data.money)
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ])
                              }
                            ),
                            _c("tr", [
                              _c("td", { attrs: { colspan: 6 } }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      itemData.dataList &&
                                        itemData.dataList.length > 0
                                        ? itemData.dataList[
                                            itemData.dataList.length - 1
                                          ].name
                                        : ""
                                    ) +
                                    "\n                "
                                ),
                              ]),
                            ]),
                          ],
                          2
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "size-note-pdf",
                          staticStyle: {
                            "margin-top": "4px",
                            "font-style": "italic",
                            "margin-bottom": "3px",
                            color: "red",
                          },
                        },
                        [
                          _vm._v(
                            "\n            *" +
                              _vm._s(itemData.bankInfo) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c(
                        "el-row",
                        { staticStyle: { "margin-top": "5px" } },
                        [
                          _c("el-col", { staticClass: "print__left" }, [
                            _c("span", [
                              _c("b", [_vm._v("STK:")]),
                              _vm._v(" " + _vm._s(itemData.accountNumberBank)),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c("el-col", [
                            _c("span", [
                              _c("b", [_vm._v("Chủ TK:")]),
                              _vm._v(" " + _vm._s(itemData.fullNameBank)),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c("el-row", [
                        _c("span", [
                          _c("b", [_vm._v("Ngân hàng:")]),
                          _vm._v(" " + _vm._s(itemData.bankNameBank)),
                        ]),
                      ]),
                      _c(
                        "el-row",
                        { staticClass: "footer_field" },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("b", [_vm._v("Người nộp tiền")]),
                          ]),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("b", [_vm._v("Người lập phiếu")]),
                          ]),
                          _c(
                            "el-col",
                            {
                              staticStyle: { "margin-top": "70px" },
                              attrs: { offset: 12, span: 12 },
                            },
                            [_c("b", [_vm._v(_vm._s(itemData.userCreate))])]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        }),
        0
      ),
      _c(
        "div",
        [
          _c(
            "el-dialog",
            {
              attrs: {
                title: "Thiết lập cỡ chữ",
                visible: _vm.dialogVisible,
                "close-on-click-modal": false,
                width: "300px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-top": "8px" },
                      attrs: { span: 8 },
                    },
                    [_c("span", [_vm._v("Chọn cỡ chữ")])]
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "70px" },
                          attrs: { placeholder: "Chọn cỡ chữ", size: "smail" },
                          model: {
                            value: _vm.customFontSize,
                            callback: function ($$v) {
                              _vm.customFontSize = $$v
                            },
                            expression: "customFontSize",
                          },
                        },
                        _vm._l(_vm.listFontSize, function (item) {
                          return _c("el-option", {
                            key: item,
                            attrs: { label: item, value: item },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("Đóng")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }